export {
  BNPL_EXPERIMENT_FLAG_KEY,
  useBnplExperimentVariant,
} from './useBnplExperimentVariant';
export type { UseBnplExperimentVariantResult } from './types';
